/* START CONSTANT SECTION COPIED FROM KARMA */

export const CONST_APP_NAME = "Jurnal Karma" as const;
export const CONST_APP_DESCRIPTION =
  "Add-on library for delphi 7 executables Jurnal Quick" as const;

export const CONST_TILE_ALL_TILES = "gzAllTiles" as const;
export const CONST_TILE_WORK_LAST = "gzWorkData" as const;
export const CONST_TILE_WORK_FAVS = "gzFavTexts" as const;
export const CONST_TILE_DONUT = "gzDonut" as const;
export const CONST_TILE_SKEY = "gzSankey" as const;
export const CONST_TILE_SKEYUSER = "gzSankeyUser" as const;
export const CONST_TILE_FREQ = "gzFrequency" as const;
export const CONST_TILE_CALENDAR = "gzCalendar" as const;
export const CONST_TILE_HEATMAP = "gzHeatmap" as const;
export const CONST_INSIDER_MAIN = "iMain" as const;

//from zebra template//
export const CONST_RED_ALERT = "%REDALERTALERT%";
//GRID SIZE, GRID LAYOUT
export const GRID_LAYOUTS: { [key: number]: string } = {
  0: "29.5cm",
  1: `${29.5 * 1.61803}cm`,
  2: "100%",
}; // 0: portrait, 1: landscape, 2: Fullscreen
export const GRID_LAYOUTS_NUMBER = { 0: 29.5, 1: 29.5 * 1.61803 };

export const palette_red2blue = [
  "#eb6270",
  "#e4727d",
  "#df808c",
  "#dc8994",
  "#dc8d99",
  "#dc929f",
  "#daa0ad",
  "#d9aeba",
  "#dbb5c1",
  "#dae7f8",
  "#ccdcf1",
  "#c1d1ea",
  "#b4c5e3",
  "#a6b9dd",
  "#9cafd6",
  "#8ea4d0",
  "#7d96cc",
  "#6688d1",
  "#5875B5",
  "#496298",
];

export const dayDrillSelectedColor = "#B9227F";
export const daySelectedColor = "#795548";

/* 

for compatibility with delphi host application, the following constants are used
imorted as they are declared in "ConstanteRO.lng" file
export const Central_TaburiMain_About='Despre Jurnal';
export const Central_TaburiMain_Cautare='Cautare contact';
export const Central_TaburiMain_CautareDosare='Cautare dosare';
export const Central_TaburiMain_Clienti='Clienti';
export const Central_TaburiMain_Contacte='Contacte';
export const Central_TaburiMain_Contracte='Contracte';
export const Central_TaburiMain_Debug='Debug';
export const Central_TaburiMain_Facturare='Facturare';
export const Central_TaburiMain_Furnizori='Furnizori';
export const Central_TaburiMain_Home='Home';
export const Central_TaburiMain_HomeSws='Home Sws';
export const Central_TaburiMain_Jurnal='Jurnal';
export const Central_TaburiMain_Management='Management';
export const Central_TaburiMain_Rapoarte='Rapoarte';
export const Central_TaburiMain_RegistruCasa='Registru de casa';
export const Central_TaburiMain_Setari='Setari';
export const Central_Taburimain_Grafice='Grafice';
*/

export const Central_TaburiMain_Panorama = "Panoramic";
export const CONST_PAGE_LISTS = "lists" as const;
export const CONST_FETCH_CANCELED = "FETCH_CANCELED" as const;
export const CONST_QUEUE_REQUEST = "QUEUE_REQUEST" as const;
// SYNCHRONIZATION PREFIXES
export const CONST_PREFIX_FROM_JS = "@FROM_JS::";
export const CONST_PREFIX_FROM_PAS = "@FROM_PAS::";
// Api names //
export const CONST_listQueryState = "listQueryState" as const;
export const CONST_listUiState = "listUiState" as const;
export const CONST_LIST_OF_CONTACTS = "listOf_contacts" as const;
export const CONST_LIST_OF_PERSONS = "listOf_persons" as const;
export const CONST_LIST_OF_MATTERS = "listOf_matters" as const;
export const CONST_LIST_OF_MYWORK = "listOf_mywork" as const;
export const CONST_LIST_SS_OF_MYWORK = "ss_listOf_mywork" as const;
export const CONST_LIST_SS_OF_AVO = "ss_listOf_avocati" as const;
export const CONST_LIST_SS_OF_CTRDOSARE = "ss_listOf_ctrdosare" as const;
export const CONST_LIST_SS_OF_PROFORMA = "ss_listOf_proforma" as const;
export const CONST_LIST_SS_OF_INVOICE = "ss_listOf_invoice" as const;
/* 
ui list groups

important! 
avoid to change this values, 
IF YOU HAVE TO, THEN CHANGE IN DATABASE ACCORDINGLY:
TABLE: "KARMA_LIST_REPORTS " COLUMN: "GROUP_DISPLAY_NAME"
*/
export const CONST_LSTGRP_IMPLICIT = "IMPLICIT" as const;
export const CONST_LSTGRP_SELECTIE = "CRITERIU" as const;
export const CONST_LSTGRP_FAVORITE = "FAVORITE" as const;
export const CONST_LSTGRP_USER = "USER" as const;
export const CONST_LSTGRP_ISTORIC = "ISTORIC" as const;
// DO NOT CHANGE THE KEY NAMES AND ORDER UNLESS YOU KNOW WHAT YOU ARE DOING ( why? because they are used in database )
// NOTE: FEEL FREE TO CHANGE THE DICTIONARY VALUES //
export const CONST_LSTGRP_DICTIONARY = {
  [CONST_LSTGRP_IMPLICIT]: "Implicit", // ANY STRING ON SCREEN...
  [CONST_LSTGRP_SELECTIE]: "Criterii de selectie",
  [CONST_LSTGRP_FAVORITE]: "Favorite",
  [CONST_LSTGRP_USER]: "Personalizate",
  [CONST_LSTGRP_ISTORIC]: "Istoric",
} as const;
Object.freeze(CONST_LSTGRP_DICTIONARY);

export const CONST_LSTORIGIN_CONTACTE = "LIST_CONTACTE_ORIGIN" as const;
export const CONST_LSTORIGIN_PERSOANE = "LIST_PERSOANE_ORIGIN" as const;
export const CONST_LSTORIGIN_CONTPERS_MD =
  "LIST_CONTACTE_PERSOANE_ORIGIN" as const;
export const CONST_LISTORIGIN_WORK = "LIST_WORK_ORIGIN" as const;
export const CONST_LISTORIGIN_AVOCATI = "LIST_AVOCATI_ORIGIN" as const;
export const CONST_LISTORIGIN_CTRDOSARE = "LIST_CTRDOSARE_ORIGIN" as const;
export const CONST_LISTORIGIN_PROFORMA = "LIST_PROFORMA_ORIGIN" as const;
export const CONST_LISTORIGIN_INVOICE = "LIST_INVOICE_ORIGIN" as const;
// [##findme##delphi-javascript##0423##]
export const CONST_LISTORIGIN_DICTIONARY = {
  [CONST_LSTORIGIN_CONTACTE]: "Contacte",
  [CONST_LSTORIGIN_PERSOANE]: "Persoane",
  [CONST_LSTORIGIN_CONTPERS_MD]: "Contacte_Persoane",
  [CONST_LISTORIGIN_WORK]: "Activiati",
  [CONST_LISTORIGIN_AVOCATI]: "Avocati",
  [CONST_LISTORIGIN_CTRDOSARE]: "Contracte_Dosare",
  [CONST_LISTORIGIN_PROFORMA]: "Facturi_Proforma",
  [CONST_LISTORIGIN_INVOICE]: "Facturi_Fiscale",
} as const;

/* END CONSTANT SECTION COPIED FROM KARMA */
export const CONST_CCH_PANORAMIC = 1;
export const CONST_CCH_REPORTS = 2;
export const CONST_CCH_INVOICING = 3;
export const CONST_CCHCH_PROFORMA = 4;
export const CONST_CCHCH_TRACKING = 5;
export const CONST_CCHCH_FISCAL = 6;

export enum ECChooserPage {
  CONST_CCH_PANORAMIC = 1,
  CONST_CCH_REPORTS = 2,
  CONST_CCH_INVOICING = 3,
  CONST_CCHCH_PROFORMA = 4,
  CONST_CCHCH_TRACKING = 5,
  CONST_CCHCH_FISCAL = 6,
}
// BIG CONFUSION WITH THE SAME NAME IN STATE\CONSTATS.TS
// COMMAND BUTTON GROUP INSIDER MAIN =CMD_BGIM
// export const enum EMenuCmdTab {
//   CMD_BGIM_CLIENTS = "CLIENTS",
//   CMD_BGIM_EMITENT = "EMITENT",
//   CMD_BGIM_MESSAGES = "spv", // 'MESSAGES',
//   CMD_BGIM_INVOICE_TRACKING = "INVOICE_TRACKING",
//   CMD_BGIM_INVOICE = "BGM_INVOICE",
//   // CMD_BGIM_SETTINGS = 'SETTINGS',
//   CMD_BGIM_REPORTS = "REPORTS",
//   // settings-invoice series
//   CMD_BGIM_INVOICE_SERIES = "INVOICE_SERIES",
//   // settings -license
//   CMD_BGIM_LICENSE = "LICENSE",
//   // settings - OAuth2
//   CMD_BGIM_OAUTH2 = "OAUTH2",
// }
